import {Component, Inject, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {SiteService} from './services/site.service';
import {DOCUMENT} from '@angular/common';
import {HttpResponse} from '@angular/common/http';
import {CustomHttpResponse} from './model/custom-http-response';
import {Subscription} from 'rxjs';

interface RestaurantConfig {
  name: string;
  logo: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  subscriptions: Subscription[] = [];

  constructor(
    private titleService: Title,
    private siteService: SiteService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.siteService.getConfiguration().subscribe({
        next: (response: HttpResponse<CustomHttpResponse>) => {
          const config = response.body?.data as RestaurantConfig | undefined;

          if (config) {
            const restaurantName = config.name?.trim();
            if (restaurantName) {
              this.titleService.setTitle(restaurantName);
            } else {
              this.titleService.setTitle('');
            }

            if (config.logo) {
              let link: HTMLLinkElement | null = this.document.querySelector('link[rel="icon"]');

              if (!link) {
                link = this.document.createElement('link');
                link.rel = 'icon';
                this.document.head.appendChild(link);
              }

              link.href = config.logo;
              link.type = 'image/png';


            }
          }
        },
        error: () => {
          this.titleService.setTitle('');
        }
      })
    );
  }
}
